import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        document.body.classList.add('bg-prospectGradient', 'bg-400', 'animate-gradientMove')
        document.querySelector('#main').classList.add('bg-none')
    }

    disconnect() {
        document.body.classList.remove('bg-prospectGradient', 'bg-400', 'animate-gradientMove')
        document.querySelector('#main').classList.remove('bg-none')
    }
}